// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__ek1ts","col":"styles_col__3tVNt"};